import React from 'react';

function About() {
  return (
    <section id="about" className="bg-gradient-to-b from-indigo-900 via-black-200 to-black  text-slate-200 py-40 md:py-52">
      <div className="container mx-auto px-4 sm:px-10 ">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="text-2xl md:text-4xl font-bold mb-6">About Me</h2>
          <p className="text-gray-400 text-xs sm:text-xs md:text-xl  ">Well-qualified Full Stack Developer familiar with a wide rang of programming utilities and languages. Knowledgeable backend and frontend development requirements. Handles any part of the process with ease. Collaborative team player with excellent technical abilities.</p>
        
        {/* More content goes here */}
        <p className="text-gray-400 text-xs sm:text-xxs md:text-xl ">Offering 8 months of experience in the management field and 6 months of related experience. Looking forward to making a significant contribution to an organization through dedicated effort.</p>
        </div>
      </div>
    </section>
  );
}

export default About;












// import React from "react";

// const About = () => {
//   return (
//     <div
//       name="about me"
//       className="w-full h-screen bg-purple-300 bg-gradient-to-b from-blue-500 text-sky-900"
//     >
//       <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full" >
//         <div className="pb-8">
//           <p className="text-4xl font-bold  border-b-4 border-gray-500 p-2 inline" >
//             About Me
//           </p>
//         </div>

//         <p className="lg:text-xl mt-10">
//         Well-qualified Full Stack Developer familiar with a wide range
//         of programming utilities and languages. Knowledgeable of
//         backend and frontend development requirements. Handles any
//         part of the process with ease. Collaborative team player with
//         excellent technical abilities.

//         </p>

//         <br />

//         <p className="lg:text-xl">
//         Offering 8 months of experience in
//         the management field and 6 months of related experience.
//         Looking forward to making a significant contribution to an
//         organization through dedicated effort.
//         </p>
//       </div>
//     </div>
//   );
// };
// export default About